"use client";
import {
  getInjectedConnector,
  hasInjectedProvider
} from "./chunk-AWVQ5XXE.js";

// src/wallets/walletConnectors/braveWallet/braveWallet.ts
var braveWallet = () => ({
  id: "brave",
  name: "Brave Wallet",
  rdns: "com.brave.wallet",
  iconUrl: async () => (await import("./braveWallet-BTBH4MDN.js")).default,
  iconBackground: "#fff",
  installed: hasInjectedProvider({ flag: "isBraveWallet" }),
  downloadUrls: {},
  createConnector: getInjectedConnector({ flag: "isBraveWallet" })
});

export {
  braveWallet
};
